import React from "react";
import PageWithHistory from "../../helpers/page-with-history";
import WineStats from "./wine-stats";

const Analyze = props => (
  <PageWithHistory title="View Your Progress" dataComponent={WineStats} />
);

export default Analyze;
